module.exports = __webpack_public_path__ + "img/auth-考试宝典-山河医学网授权书.5a140e21.jpg";